import { colors } from 'design-system';
import VectorIcon from './VectorIcon';

const GiftBoxIcon = (): JSX.Element => (
  <VectorIcon width={25} height={27}>
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9783 8.36471L21.3043 5.08237L16.0869 0L12.7174 
        7.30589L10.7609 1.58823L5.54348 4.97646L9.89128 
        8.36469H0V15.1412H1.73913V27H23.2608V15.1412H25V8.36471H15.9783ZM16.527 
        2.2255L19.257 4.88489L13.6881 8.32491L16.527 2.2255ZM10.0635 3.56819L11.605 
        8.07305L7.75115 5.06981L10.0635 3.56819ZM10.7609 25.3059H3.47826V14.6105H10.7609V25.3059ZM10.7609 
        13.447H1.73913V10.0588H10.7609V13.447ZM21.5217 25.3059H14.2391V14.6105H21.5217V25.3059ZM23.2608 
        13.447H14.2391V10.0588H23.2608V13.447Z"
        fill={colors.madison}
      />
    </svg>
    ;
  </VectorIcon>
);

export default GiftBoxIcon;
